import axios from './axios';

export const startTranscode = (slug: string) => {
    return axios.post(`media/${slug}/transcode`);
}